import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Mortarboard = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.5 9.083v4.497M5.762 11.332v5.62s.562 2.249 6.183 2.249 6.183-2.248 6.183-2.248v-5.621M2.775 8.662l8.257-3.67a2.25 2.25 0 0 1 1.825 0l8.257 3.67a.461.461 0 0 1 0 .843l-8.257 3.67a2.25 2.25 0 0 1-1.825 0l-8.257-3.67a.46.46 0 0 1 0-.843"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Mortarboard) as SvgIcon;
export { ForwardRef as ReactComponent };
